/**
 * Omit time-of-day from /deals when unset or "all_day" — backend interprets all_day as a restrictive match.
 */
export const normalizeMealTimeForApi = (timeOfDay) => {
  const t = typeof timeOfDay === "string" ? timeOfDay.trim() : "";
  if (!t || t === "all_day") return "";
  return t;
};
